import {
  Box,
  Card,
  Typography,
  MenuItem,
  Select,
  FormControl,
  Button,
  IconButton,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  TextField,
  CircularProgress,
  DialogActions,
  useTheme,
  useMediaQuery,
  Autocomplete,
  Popper,
  Chip,
} from "@mui/material";
import archives from "../../assets/achives.png";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import videoCamera from "../../assets/VideocameraAdd.png";
import bulk from "../../assets/bulkedit.png";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import tagIcon from "../../assets/Tag.png";
import deleteicon from "../../assets/trash.png";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Auth } from "../../contexts/AuthContext";
import {
  AddMediaToLibrary,
  changeMediaToArchive,
  deleteMediaById,
  getAllAdminMedia,
  getAllMediaByType,
  restoreMedia,
  uploadMedia,
  uploadZipFile,
} from "../../services/postService";
import { toast } from "react-toastify";
import { employeeTrendingListing } from "../../services/adminServices";
import { getResolvedPosterUrl, BLACK_THUMBNAIL } from "../../shared/mediaResolver";

const isBunnyStreamVideo = (media = {}) =>
  media?.storageProvider === "BUNNY_STREAM" ||
  Boolean(
    (media?.playbackUrl && (media.playbackUrl.includes("mediadelivery.net") || media.playbackUrl.includes("bunnycdn.com"))) ||
    (media?.url && (media.url.includes("mediadelivery.net") || media.url.includes("bunnycdn.com")))
  );

const isReadyForPlayback = (media = {}) => {
  const status = String(media?.processingStatus || "").toUpperCase();
  if (status === "PROCESSING" || status === "IN_PROGRESS" || status === "ENCODING" || status === "PENDING" || status === "FAILED") {
    return false;
  }
  const videoUrl = media?.playbackUrl || media?.url || media?.fileUrl || media?.mediaUrl;
  return Boolean(videoUrl);
};
const BUNNY_CARD_ASPECT_RATIO = "16 / 9";

const getBunnyEmbedUrl = (playbackUrl = "", { autoplay = false } = {}) => {
  try {
    const url = new URL(playbackUrl);
    const [, playSegment, libraryId, videoGuid] = url.pathname.split("/");
    const embedUrl =
      playSegment === "play" && libraryId && videoGuid
        ? new URL(`https://iframe.mediadelivery.net/embed/${libraryId}/${videoGuid}`)
        : new URL(playbackUrl);
    if (autoplay) {
      embedUrl.searchParams.set("autoplay", "true");
    }
    return embedUrl.toString();
  } catch (error) {
    return playbackUrl;
  }
};

const VideoManagement = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [image, setImage] = useState(null);
  const { categoriesData } = Auth();
  const [title, setTitle] = useState("");
  const [videoIds, setVideoIds] = useState([]);
  const [category, setCategory] = useState("All Category");
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [open, setOpen] = useState(false);
  const [bulkUpload, setBulkUpload] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [open1, setOpen1] = useState(false);
  const [totalMedia, setTotalMedia] = useState([]);
  const [successCount, setSuccessCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [loader, setLoader] = useState(false);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [selectedCategoryId, setSelectedCategoryId] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [details, setDetails] = useState({});
  const [singleData, setSingleData] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [restoreLoading, setRestoreLoading] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [trendsData, setTrendsData] = useState([]);
  const [trendsInput, setTrendsInput] = useState("");
  const [selectedTrends, setSelectedTrends] = useState([]);
  const [archived, setArchived] = useState(false);
  const [activeBunnyId, setActiveBunnyId] = useState(null);
  const addTrends = (newValue) => {
    if (!newValue) {
      setTrendsInput("");
      return;
    }
    const tags = String(newValue)
      .split(",")
      .map((t) => t.trim().replace(/^#/, ""))
      .filter(Boolean);
    if (tags.length === 0) {
      setTrendsInput("");
      return;
    }
    setSelectedTrends((prev) => {
      const next = [...prev];
      for (const tag of tags) {
        if (!next.includes(tag)) next.push(tag);
      }
      return next;
    });
    setTrendsInput("");
  };
  const removeTrends = (trend) => {
    setSelectedTrends((prev) => prev.filter((t) => t !== trend));
  };
  const fetchAllTrendingTopics = async () => {
    try {
      const response = await employeeTrendingListing();
      if (response?.status === true) {
        setTrendsData(response?.trendingHashtags || []);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  const pauseAllLibraryVideos = () => {
    document.querySelectorAll(".library-video").forEach((videoEl) => {
      if (typeof videoEl.pause === "function") {
        videoEl.pause();
      }
    });
  };

  const handleToggleDetails = (index) => {
    setExpandedIndex((currentIndex) => (currentIndex === index ? null : index));
  };
  const handleFileUpload = async (file) => {
    const videoURL = URL.createObjectURL(file);

    const formData = new FormData();

    formData.append("files", file);
    formData.append("mediaType", "video");
    setLoader(true);
    setProgress(0);
    try {
      const response = await uploadMedia(formData, (percent) => {
        setProgress(percent);
      });
      if (response?.status === true) {
        setVideoIds(response?.mediaUploadData?.videoIds);
        setImage(videoURL);
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoader(false);
      setProgress(0);
    }
  };

  const fetchAllArchived = () => {
    fetchAllMedia("archived");
    setArchived(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handleFileUpload(file);
  };

  const handleBrowse = (e) => {
    const file = e.target.files[0];
    if (file) handleFileUpload(file);
  };

  const onClose = () => {
    setBulkUpload(false);
    setImage(null);
    setOpen(false);
    setTitle("");
    setCategory("");
    setTags([]);
    setTagInput("");
    setFile(null);
    setProgress(0);
    setTotalItems(0);
    setSuccessCount(0);
    setFailedCount(0);
    setVideoIds([]);
    setTrendsInput("");
    setSelectedTrends([]);
  };

  const handleOpen = () => {
    onClose();
    setOpen(true);
  };

  const handleDeleteFile = () => {
    setFile(null);
    setProgress(0);
    setTotalItems(0);
    setSuccessCount(0);
    setFailedCount(0);
    setVideoIds([]);
  };
  const handleBulkUpload = () => {
    onClose();
    setBulkUpload(true);
  };

  const toggleSelect = (video) => {
    setSelected((prev) =>
      prev.includes(video)
        ? prev.filter((v) => v !== video)
        : prev.length < 6
        ? [...prev, video]
        : prev
    );
  };

  const handleLocalVideoPlay = (index) => {
    setActiveBunnyId(null);
    const allVideoEls = document.querySelectorAll(".library-video");

    allVideoEls.forEach((vid, i) => {
      if (i !== index) {
        vid.pause();
      }
    });
  };

  const handlePlayBunnyVideo = (media) => {
    pauseAllLibraryVideos();
    const mediaId = media?.id || media?.playbackUrl || media?.url || media?.fileUrl || null;
    setActiveBunnyId(mediaId);
  };

  const handlePlay = () => {
    const videoEl = videoRef.current;
    if (!videoEl) return;

    if (isPlaying) {
      videoEl.pause();
      setIsPlaying(false);
    } else {
      videoEl.play();
      setIsPlaying(true);
    }
  };

  const validateForm = () => {
    let errors = {};

    if (!title.trim()) errors.title = "Title is required";
    if (!category || category === "All Category")
      errors.category = "Category is required";
    // Hashtags / Trending topics are optional
    // if (selectedTrends.length === 0)
    //   errors.tags = "At least one tag is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const fetchAllMedia = async (data) => {
    try {
      const payload = {
        type: "video",
        categoryId: selectedCategoryId === "all" ? "" : selectedCategoryId,
        status: data,
      };
      const response = await getAllAdminMedia(payload, page, limit);
      if (response?.status === true) {
        setTotalMedia(response?.mediaLibrary);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllMedia(archived ? "archived" : "all");
    fetchAllTrendingTopics();
  }, [selectedCategoryId]);
  const handleChange = (event) => {
    setSelectedCategoryId(event.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const payload = {
          mediaIds: videoIds,
          title: title,
          mediaType: "video",
          categoryId: Number(category),
          hashtags: selectedTrends,
        };
        setLoader(true);
        const response = await AddMediaToLibrary(payload);
        if (response?.status === true) {
          toast.success("Video added to library successfully!");
          onClose();
          setVideoIds([]);
          setTitle("");
          setCategory("");
          setTags([]);
          setTagInput("");
          fetchAllMedia("all");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoader(false);
      }
    }
  };

  const handleZipFileUpload = async (e) => {
    const uploadedFile = e.target.files[0];

    try {
      if (uploadedFile) {
        setFile(uploadedFile);
        const payload = new FormData();
        payload.append("zipFile", uploadedFile);
        payload.append("mediaType", "VIDEO");
        const response = await uploadZipFile(payload);
        if (response?.status) {
          toast.success("Bulk upload successful!");
          const { successCount, videoIds, failedCount, totalFiles } =
            response.mediaUploadData;
          setVideoIds(videoIds);
          setSuccessCount(successCount);
          setFailedCount(failedCount);
          setTotalItems(totalFiles);
          setProgress(100);
        } else {
          setProgress(0);
          setSuccessCount(0);
          setFailedCount(0);
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
      setProgress(0);
      setSuccessCount(0);
      setFailedCount(0);
    } finally {
    }
  };

  const handleZipConfirm = async () => {
    try {
      if (!category) {
        toast.error("Please select a category.");
        return;
      }
      if (!videoIds || videoIds.length === 0) {
        toast.error("Please upload image.");
        return;
      }
      // Hashtags / Trending topics are optional
      // if (!selectedTrends || selectedTrends.length === 0) {
      //   toast.error("Please add at least one hashtag.");
      //   return;
      // }

      const payload = {
        mediaIds: videoIds,
        title: title,
        mediaType: "video",
        categoryId: Number(category),
        hashtags: selectedTrends || [],
      };
      setLoader(true);
      const response = await AddMediaToLibrary(payload);
      if (response?.status === true) {
        toast.success("Video added to library successfully!");
        onClose();
        setVideoIds([]);
        setTitle("");
        setCategory("");
        setTags([]);
        setTagInput("");
        fetchAllMedia("all");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
    setDetails({});
    setRestore(false);
  };

  const deleteClose = () => {
    setOpen1(false);
  };

  const onConfirm = async () => {
    setDeleteLoading(true);
    try {
      const response = await deleteMediaById(singleData?.id);
      if (response?.status === true) {
        toast.success("Media deleted successfully!");
        fetchAllMedia("all");
        setOpen1(false);
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setDeleteLoading(false);
    }
  };
  const handleOpenDeleteModal = (data) => {
    setSingleData(data);
    setOpen1(true);
  };

  const handleChangeToArchives = async () => {
    setArchiveLoading(true);
    try {
      // console.log(details, "details");
      const payload = { id: details?.id };
      const response = await changeMediaToArchive(payload);
      if (response?.status === true) {
        toast.success(response?.message || "");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      fetchAllMedia(archived ? "archived" : "all");
      setModalOpen(false);
      setArchiveLoading(false);
    }
  };
  const [restore, setRestore] = useState(false);
  const handleRestoreFromArchives = async () => {
    setRestoreLoading(true);
    try {
      const payload = { id: details?.id };
      const response = await restoreMedia(payload);
      if (response?.status === true) {
        toast.success(response?.message || "");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      fetchAllMedia(archived ? "archived" : "all");
      setRestore(false);
      setRestoreLoading(false);
    }
  };

  const handleOpenRestoreModal = (img, index) => {
    setRestore(true);
    setDetails(img);
  };

  const handleOpenArchivesModal = (img, index) => {
    setModalOpen(true);
    setDetails(img);
  };

  return (
    <>
      <Dialog
        open={open1}
        onClose={deleteClose}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "20px",
            maxWidth: "420px",
            width: "100%",
          },
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={deleteClose}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            fontWeight: "500",
            color: "#484848",
            fontSize: "20px",
            p: 0,
            mb: 1,
          }}
        >
          Delete?
        </DialogTitle>
        <DialogContent sx={{ padding: "20px 5px" }}>
          <Typography
            sx={{
              fontSize: "16px",
              color: "#616161",
              mb: 3,
              textAlign: "start",
            }}
          >
            Are you sure you want to delete this image?
          </Typography>

          {/* Buttons */}
          <Box display="flex" justifyContent="end" gap={2}>
            <Button
              onClick={deleteClose}
              disabled={deleteLoading}
              sx={{
                backgroundColor: "#F4F0FF",
                color: "#0D47A1",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
                borderRadius: "8px",
                px: 4,
                py: 1,
                "&:hover": { backgroundColor: "#E9D5FF" },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              disabled={deleteLoading}
              sx={{
                backgroundColor: "#D93A3A",
                color: "#fff",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
                borderRadius: "8px",
                px: 4,
                py: 1,
                "&:hover": { backgroundColor: "#b71c1c" },
              }}
            >
              {deleteLoading ? "Deleting..." : "Confirm"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={restore}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "20px",
            padding: "24px",
            position: "relative",
          },
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 12, right: 12 }}
        >
          <CloseIcon sx={{ color: "#000" }} />
        </IconButton>

        {/* Title */}
        <DialogTitle
          sx={{
            fontWeight: "500",
            color: "#3B3B3B",
            fontSize: "24px",
            p: 0,
            mb: 1,
          }}
        >
          Are you sure ?
        </DialogTitle>

        {/* Subtitle */}
        <DialogContent sx={{ px: 0 }}>
          <Typography
            sx={{
              color: "#95919D",
              fontSize: "16px",
              fontWeight: 400,
              width: "90%",
            }}
          >
            you want to restore from archives
          </Typography>
        </DialogContent>

        {/* Buttons */}
        <DialogActions
          sx={{
            px: 0,
            pt: 4,
            display: "flex",
            justifyContent: "end",
            gap: 2,
          }}
        >
          <Button
            onClick={handleClose}
            disabled={restoreLoading}
            sx={{
              backgroundColor: "#F4F0FF",
              color: "#0047AB",
              borderRadius: "8px",
              textTransform: "none",
              border: "1px solid #F4F0FF",
              px: 4,
              py: 1,
              fontWeight: 500,
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#ece9fd",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleRestoreFromArchives}
            disabled={restoreLoading}
            sx={{
              backgroundColor: "#0047AB",
              color: "#fff",
              borderRadius: "8px",
              textTransform: "none",
              px: 4,
              py: 1,
              fontWeight: 500,
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#002f8c",
              },
            }}
          >
            {restoreLoading ? "Restoring..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={modalOpen}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "20px",
            padding: "24px",
            position: "relative",
          },
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 12, right: 12 }}
        >
          <CloseIcon sx={{ color: "#000" }} />
        </IconButton>

        {/* Title */}
        <DialogTitle
          sx={{
            fontWeight: "500",
            color: "#3B3B3B",
            fontSize: "24px",
            p: 0,
            mb: 1,
          }}
        >
          Are you sure ?
        </DialogTitle>

        {/* Subtitle */}
        <DialogContent sx={{ px: 0 }}>
          <Typography
            sx={{
              color: "#95919D",
              fontSize: "16px",
              fontWeight: 400,
              width: "90%",
            }}
          >
            you want to move on archives
          </Typography>
        </DialogContent>

        {/* Buttons */}
        <DialogActions
          sx={{
            px: 0,
            pt: 4,
            display: "flex",
            justifyContent: "end",
            gap: 2,
          }}
        >
          <Button
            onClick={handleClose}
            disabled={archiveLoading}
            sx={{
              backgroundColor: "#F4F0FF",
              color: "#0047AB",
              borderRadius: "8px",
              textTransform: "none",
              border: "1px solid #F4F0FF",
              px: 4,
              py: 1,
              fontWeight: 500,
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#ece9fd",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleChangeToArchives}
            disabled={archiveLoading}
            // variant="contained"
            sx={{
              backgroundColor: "#0047AB",
              color: "#fff",
              borderRadius: "8px",
              textTransform: "none",
              px: 4,
              py: 1,
              fontWeight: 500,
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#002f8c",
              },
            }}
          >
            {archiveLoading ? "Archiving..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      <Card
        className="settings-container"
        elevation={0}
        sx={{ p: { xs: 1.5, sm: 2 }, borderRadius: 4 }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1.5}
          flexWrap="wrap"
          gap={2}
        >
          <Box display="flex" alignItems="center" gap={1}>
            {archived && (
              <IconButton
                onClick={() => {
                  setArchived(false);
                  fetchAllMedia("all");
                }}
                size="small"
                sx={{
                  color: "#0047AB",
                  backgroundColor: "#F4F0FF",
                  borderRadius: "8px",
                  p: "4px 8px",
                  "&:hover": {
                    backgroundColor: "#e4dbff",
                  },
                }}
                title="Back to Video Library"
              >
                <ArrowBackIcon fontSize="small" />
              </IconButton>
            )}
            <Typography
              variant="h6"
              fontSize={15}
              color="#3B3B3B"
              fontWeight={500}
            >
              {archived ? "Archives" : "Videos"} (
              <span style={{ color: "#2D76DC" }}>{totalMedia?.length}</span>)
            </Typography>
          </Box>

          <Box
            display="flex"
            flexWrap="wrap"
            gap={1.5}
            alignItems="center"
            sx={{
              width: { xs: "100%", md: "auto" },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              sx={{
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#95919D",
                  fontWeight: 400,
                  fontSize: 13,
                  whiteSpace: "nowrap",
                  minWidth: { xs: "65px", sm: "auto" },
                }}
              >
                Category:
              </Typography>

              <FormControl
                size="small"
                fullWidth
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  flex: { xs: 1, sm: "none" },
                }}
              >
                <Select
                  defaultValue="all"
                  displayEmpty
                  value={selectedCategoryId || "all"}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    minWidth: { xs: "100%", sm: 146 },
                    height: 33,
                    fontWeight: 500,
                    fontSize: 13,
                    color: "#111827", // Black text
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E5E7EB", // Light border
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#2563EB", // Blue focus
                    },
                    "& .MuiSelect-icon": {
                      color: "#2563EB", // Blue arrow
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 88 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                >
                  <MenuItem value="all">All Category</MenuItem>
                  {categoriesData?.map((category) => (
                    <MenuItem key={category.id} value={category.id}>
                      {category?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              gap={1}
              sx={{
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#95919D",
                  fontWeight: 400,
                  fontSize: 13,
                  whiteSpace: "nowrap",
                  minWidth: { xs: "65px", sm: "auto" },
                }}
              >
                Sort By:
              </Typography>

              <FormControl
                size="small"
                fullWidth
                sx={{
                  width: { xs: "100%", sm: "auto" },
                  flex: { xs: 1, sm: "none" },
                }}
              >
                <Select
                  defaultValue="Recently Added"
                  displayEmpty
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    minWidth: { xs: "100%", sm: 148 },
                    height: 33,
                    fontWeight: 500,
                    fontSize: 13,
                    color: "#111827", // Black text
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E5E7EB", // Light border
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#2563EB", // Blue focus
                    },
                    "& .MuiSelect-icon": {
                      color: "#2563EB", // Blue arrow
                    },
                  }}
                >
                  <MenuItem value="Recently Added">Recently Added</MenuItem>
                  <MenuItem value="Oldest">Oldest</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {!archived ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "nowrap",
                  whiteSpace: "nowrap",
                  width: { xs: "100%", md: "auto" },
                  flex: { xs: "1 1 100%", md: "none" },
                }}
              >
                <Box
                  display={"flex"}
                  bgcolor={"#F4F0FF"}
                  borderRadius={1}
                  padding={"7px 9px"}
                  alignItems="center"
                  justifyContent="center"
                  gap={1}
                  sx={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}
                  onClick={fetchAllArchived}
                >
                  <img
                    src={archives}
                    alt="Archive"
                    width="18px"
                    height={"18px"}
                  />
                  <Typography fontSize={"13px"} variant="body1" color="#3B3B3B">
                    Archives
                  </Typography>
                </Box>

                <Box
                  display={"flex"}
                  bgcolor={"#F4F0FF"}
                  borderRadius={1}
                  padding={"7px 9px"}
                  alignItems="center"
                  justifyContent="center"
                  gap={1}
                  sx={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}
                  onClick={handleBulkUpload}
                >
                  <img src={bulk} alt="Bulk" width="16px" />
                  <Typography fontSize={"13px"} variant="body1" color="#3B3B3B">
                    Bulk Upload
                  </Typography>
                </Box>

                <Button
                  sx={{
                    bgcolor: "#0047AB",
                    color: "#fff",
                    fontSize: "13px",
                    fontWeight: "400",
                    padding: "6px 12px !important",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    flex: 1,
                    "&:hover": {
                      bgcolor: "#1E40AF",
                    },
                  }}
                  onClick={handleOpen}
                >
                  + Video
                </Button>
              </Box>
            ) : (
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  setArchived(false);
                  fetchAllMedia("all");
                }}
                sx={{
                  borderColor: "#0047AB",
                  color: "#0047AB",
                  fontSize: "13px",
                  fontWeight: "500",
                  padding: "5px 12px !important",
                  textTransform: "none",
                  borderRadius: "8px",
                  "&:hover": {
                    borderColor: "#002f8c",
                    backgroundColor: "#F4F0FF",
                  },
                }}
              >
                Back to Library
              </Button>
            )}
          </Box>
        </Box>
        <Box
          className="scroll-container"
          sx={{
            height: { xs: "auto", md: "calc(100vh - 64px)" },
            overflowY: { xs: "visible", md: "auto" },
            px: 0,
          }}
        >
          {totalMedia?.length > 0 ? (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
                gap: "16px",
              }}
            >
              {totalMedia?.map((media, index) => {
                const bunnyMediaId = media?.id || media?.playbackUrl || null;
                const isActiveBunny =
                  bunnyMediaId !== null && activeBunnyId === bunnyMediaId;

                return (
                  <Box
                    key={media?.id || index}
                    sx={{
                      mb: 2,
                      borderRadius: 3,
                      overflow: "hidden",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 2px 9px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                  {/* Video */}
                  <Box
                    sx={{
                      position: "relative",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    {media?.isArchived === true ? (
                      <Box
                        // bgcolor={"#F4F0FF"}
                        borderRadius={1}
                        padding={"6px 10px"}
                        zIndex={1}
                        sx={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          // "&:hover": {
                          bgcolor: "#F4F0FF",
                          cursor: "pointer",
                          color: "#3B3B3B",
                          // },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenRestoreModal(media, index);
                        }}
                      >
                        <Typography
                          display={"flex"}
                          variant="body1"
                          color="#fff"
                          sx={{
                            // "&:hover": {
                            color: "#3B3B3B",
                            // },
                            fontSize: "12px",
                          }}
                        >
                          <img src={archives} alt="Archive" width="18px" />{" "}
                          Archive
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        // bgcolor={"#F4F0FF"}
                        borderRadius={1}
                        padding={"6px 10px"}
                        zIndex={1}
                        sx={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          "&:hover": {
                            bgcolor: "#F4F0FF",
                            cursor: "pointer",
                            color: "#3B3B3B",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenArchivesModal(media, index);
                        }}
                      >
                        <Typography
                          display={"flex"}
                          variant="body1"
                          color="#fff"
                          sx={{
                            "&:hover": {
                              color: "#3B3B3B",
                            },
                            fontSize: "12px",
                          }}
                        >
                          <img src={archives} alt="Archive" width="18px" />{" "}
                          Archive
                        </Typography>
                      </Box>
                    )}
                    {isBunnyStreamVideo(media) ? (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isActiveBunny) {
                            handlePlayBunnyVideo(media);
                          }
                        }}
                        sx={{
                          width: "100%",
                          aspectRatio: BUNNY_CARD_ASPECT_RATIO,
                          position: "relative",
                          cursor: "pointer",
                          backgroundColor: "#111827",
                          overflow: "hidden",
                          borderRadius: 2,
                        }}
                      >
                        {isActiveBunny && (media?.playbackUrl || media?.url || media?.fileUrl) ? (
                          <iframe
                            src={getBunnyEmbedUrl(media?.playbackUrl || media?.url || media?.fileUrl, { autoplay: true })}
                            title={media?.title || "Bunny Stream Video"}
                            style={{
                              width: "100%",
                              height: "100%",
                              border: 0,
                              display: "block",
                            }}
                            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                            allowFullScreen
                          />
                        ) : (
                          <>
                            {media?.thumbnailUrl ? (
                              <img
                                src={media.thumbnailUrl}
                                alt={media?.title || "Video thumbnail"}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  opacity: 0.92,
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  position: "absolute",
                                  inset: 0,
                                  background:
                                    "linear-gradient(180deg, #1F2937 0%, #111827 100%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#D1D5DB",
                                  px: 3,
                                  textAlign: "center",
                                }}
                              >
                                <Typography variant="body2">
                                  Thumbnail unavailable
                                </Typography>
                              </Box>
                            )}
                            <Box
                              sx={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(0, 0, 0, 0.35)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1,
                                color: "#FFFFFF",
                                textAlign: "center",
                                px: 2,
                              }}
                            >
                              <Box className="playIcon">
                                <PlayArrowIcon style={{ fontSize: 35, color: "#0047AB" }} />
                              </Box>
                            </Box>
                          </>
                        )}
                      </Box>
                    ) : (
                      <video
                        src={media?.playbackUrl || media?.url}
                        width="100%"
                        poster={getResolvedPosterUrl(media, BLACK_THUMBNAIL)}
                        style={{
                          width: "100%",
                          aspectRatio: BUNNY_CARD_ASPECT_RATIO,
                          height: "auto",
                          display: "block",
                          objectFit: "cover",
                          backgroundColor: "#111827",
                        }}
                        className="library-video"
                        preload="metadata"
                        controls
                        controlsList="nodownload"
                        onPlay={() => handleLocalVideoPlay(index)}
                      />
                    )}
                  </Box>

                  <Box bgcolor={"#F8F9FC"} sx={{ px: 1.5, py: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1.5,
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="#3F3D3D"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {media?.title || "Untitled Video"}
                      </Typography>
                      <Button
                        variant="text"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleToggleDetails(index);
                        }}
                        sx={{
                          minWidth: "auto",
                          px: 0,
                          fontSize: "13px",
                          fontWeight: 600,
                          textTransform: "none",
                          color: "#2D76DC",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {expandedIndex === index ? "Show less" : "Show more"}
                      </Button>
                    </Box>
                  </Box>

                  {/* Expand Content */}
                  <Collapse
                    in={expandedIndex === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box bgcolor={"#F8F9FC"} sx={{ px: 1.5, pb: 1.5 }}>
                      <Typography
                        variant="subtitle2"
                        color="#95919D"
                        mb={1}
                        mt={0.5}
                      >
                        Categories:
                      </Typography>
                      {media?.categories?.map((cat, i) => (
                        <Button
                          key={i}
                          size="small"
                          sx={{
                            border: "1px solid #2D76DC",
                            bgcolor: "#E7F1FF",
                            color: "#000000",
                            textTransform: "capitalize",
                            padding: "5px 10px",
                          }}
                        >
                          {cat}
                        </Button>
                      ))}

                      <Typography
                        variant="subtitle2"
                        color="#95919D"
                        mb={1}
                        mt={1.5}
                      >
                        Tags:
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        {media?.hashtags?.map((tag, i) => (
                          <Button
                            key={i}
                            size="small"
                            sx={{
                              border: "1px solid #2D76DC",
                              bgcolor: "#E7F1FF",
                              color: "#000000",
                              textTransform: "capitalize",
                              padding: "5px 10px",
                            }}
                          >
                            <img
                              style={{ width: 14, height: 14, marginRight: 2 }}
                              src={tagIcon}
                              alt="img"
                            />
                            {tag}
                          </Button>
                        ))}
                      </Box>

                      <Box mt={2} sx={{ display: "flex", gap: 1 }}>
                        {/* <Button
                          sx={{
                            bgcolor: "#FFFFFF",
                            color: "#3B3B3B",
                            textTransform: "capitalize",
                            padding: "5px 10px",
                            width: "100%",
                            fontSize: "15px",
                          }}
                        >
                          Edit
                        </Button> */}
                        <Button
                          sx={{
                            bgcolor: "#FFFFFF",
                            color: "#CB2E1C",
                            textTransform: "capitalize",
                            padding: "5px 10px",
                            width: "100%",
                            fontSize: "15px",
                          }}
                          onClick={() => handleOpenDeleteModal(media)}
                        >
                          Delete
                        </Button>
                      </Box>
                    </Box>
                  </Collapse>
                </Box>
                );
              })}
            </Box>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              py={8}
              px={2}
              bgcolor="#FFFFFF"
              borderRadius={3}
            >
              <VideoLibraryIcon sx={{ fontSize: 52, color: "#C4C4C4", mb: 1.5 }} />
              <Typography variant="h6" fontSize={16} fontWeight={500} color="#3B3B3B" mb={0.5}>
                {archived ? "No Archived Videos Found" : "No Videos Found"}
              </Typography>
              <Typography variant="body2" color="#95919D" textAlign="center" maxWidth={380}>
                {archived
                  ? "There are currently no archived videos in your library."
                  : selectedCategoryId && selectedCategoryId !== "all"
                  ? "No videos found for the selected category. Try selecting a different category or upload a new video."
                  : "No videos available in your library. Click '+ Video' above to upload your first video."}
              </Typography>
              {selectedCategoryId && selectedCategoryId !== "all" && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setSelectedCategoryId("all");
                  }}
                  sx={{
                    mt: 2,
                    textTransform: "none",
                    borderColor: "#0047AB",
                    color: "#0047AB",
                    borderRadius: "8px",
                    "&:hover": { borderColor: "#002f8c", backgroundColor: "#F4F0FF" },
                  }}
                >
                  Show All Categories
                </Button>
              )}
            </Box>
          )}
        </Box>
        <Dialog
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="md"
          PaperProps={{
            sx: {
              width: "600px",
              borderRadius: "16px",
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#484848",
            }}
          >
            Add video to library
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            {/* Upload/Preview Area */}
            <Box
              sx={{
                border: image ? "none" : "1px dashed #D9E1EC",
                background: "#F8FAFC",
                borderRadius: "8px",
                p: image ? 0 : 2,
                height: image ? "150px" : "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                mb: 3,
                overflow: "hidden",
                position: "relative",
              }}
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
            >
              {image ? (
                <>
                  <video
                    src={image}
                    muted
                    style={{
                      width: "70%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                    ref={videoRef}
                    className="library-video"
                    preload="metadata"
                    onClick={handlePlay}
                  />

                  {!isPlaying && (
                    <Box
                      sx={{
                        position: "absolute !important",
                        top: "0 !important",
                        left: "35px !important",
                        right: "217px !important",
                        bottom: "0 !important",
                        display: "flex !important",
                        alignItems: "center !important",
                        justifyContent: "center !important",
                        background: "rgba(0, 0, 0, 0.4) !important",
                        cursor: "pointer !important",
                      }}
                      onClick={handlePlay}
                    >
                      <Box className="playIcon">
                        <PlayArrowIcon
                          style={{ fontSize: 35, color: "#0047AB" }}
                        />
                      </Box>
                    </Box>
                  )}
                  <Box
                    sx={{
                      width: "20%",
                      position: "relative",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <video
                      src={image}
                      muted
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        top: 6,
                        right: 6,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        cursor: "pointer",
                      }}
                      onClick={() => setImage(null)}
                    >
                      <img
                        src={deleteicon}
                        width={16}
                        height={16}
                        alt="delete"
                      />
                      <Typography sx={{ fontSize: 12, color: "#fff" }}>
                        Delete
                      </Typography>
                    </Box>
                  </Box>
                </>
              ) : (
                <label
                  htmlFor="fileInput"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  {loader ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  ) : (
                    <>
                      <input
                        id="fileInput"
                        type="file"
                        accept="video/*" // âœ… allow MP4, MOV, AVI
                        style={{ display: "none" }}
                        onChange={handleBrowse}
                      />
                      <img
                        src={videoCamera}
                        alt="upload"
                        style={{ width: 40, height: 40, opacity: 0.6 }}
                      />
                      <Typography variant="body2" color="#121212">
                        Drop your Video here, or{" "}
                        <span style={{ color: "#2D76DC" }}> browse</span>
                      </Typography>
                      <Typography
                        variant="caption"
                        color="#95919D"
                        sx={{ fontSize: "10px" }}
                      >
                        Supports MP4, MOV & AVI up to 100MB
                      </Typography>{" "}
                    </>
                  )}
                </label>
              )}
            </Box>

            {/* Form Fields */}
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Box
                width={{ xs: "100%", md: "50%" }}
                sx={{ display: "flex", flexDirection: "column", gap: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 400,
                    color: "#95919D",
                  }}
                >
                  Title
                </Typography>
                <TextField
                  placeholder="Enter Title"
                  value={title}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 45, // total height of the input box
                    },
                  }}
                  onChange={(e) => setTitle(e.target.value)}
                  fullWidth
                  error={!!formErrors.title}
                  helperText={formErrors.title}
                />
              </Box>
              <Box
                width={{ xs: "100%", md: "50%" }}
                sx={{ display: "flex", flexDirection: "column", gap: 1 }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 400,
                    color: "#95919D",
                  }}
                >
                  Category
                </Typography>
                <Select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  fullWidth
                  sx={{ height: 45 }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                  error={!!formErrors.category}
                >
                  <MenuItem value="" disabled>
                    Select Category
                  </MenuItem>
                  {categoriesData?.map((cat) => (
                    <MenuItem key={cat?.id} value={cat?.id}>
                      {cat?.name}
                    </MenuItem>
                  ))}
                </Select>
                {formErrors.category && (
                  <Typography color="error" fontSize={12}>
                    {formErrors.category}
                  </Typography>
                )}
              </Box>
            </Box>
            {/* Trending Topics / Tags Section - Made optional & hidden */}
            {/* 
            <Box
              width={{ xs: "100%", md: "49%" }}
              sx={{
                display: "flex",
                flexDirection: "column",
                mt: 2,
                gap: 1,
              }}
            >
              <Autocomplete
                freeSolo
                options={trendsData.filter(
                  (trend) =>
                    trend.toLowerCase().includes(trendsInput.toLowerCase()) &&
                    !selectedTrends.includes(trend)
                )}
                inputValue={trendsInput}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason === "input") {
                    setTrendsInput(newInputValue);
                  } else if (reason === "reset" || reason === "clear") {
                    setTrendsInput("");
                  }
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    addTrends(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    sx={{
                      color: "#E0E0E0",
                      "& .MuiInputBase-input": {
                        fontSize: "12px",
                      },
                    }}
                    placeholder="Trending Topics"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        addTrends(trendsInput);
                      }
                    }}
                  />
                )}
                PopperComponent={(props) => (
                  <Popper
                    {...props}
                    sx={{
                      width: "200px",
                      padding: "8px",
                      "& .MuiAutocomplete-listbox": {
                        padding: "5px",
                        border: "1px solid #DEDFE5",
                        borderRadius: "8px",
                        "& li": {
                          backgroundColor: "#FFFFFF",
                          padding: "8px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "background-color 0.3s ease",
                        },
                        "& li:hover": {
                          backgroundColor: "#0047AB",
                          color: "#FFFFFF",
                        },
                      },
                    }}
                  />
                )}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option || ""
                }
                disableClearable
              />
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {selectedTrends?.map((trend, index) => (
                  <Chip
                    key={index}
                    label={trend}
                    onDelete={() => removeTrends(trend)}
                    deleteIcon={<CloseIcon fontSize="10px" />}
                    sx={{
                      backgroundColor: "#E7F1FF",
                      border: "1px solid #2D76DC",
                      color: "#2D76DC",
                      fontWeight: 400,
                      fontSize: "10px",
                      height: "24px",
                    }}
                  />
                ))}
              </Box>
            </Box>
            */}
            {formErrors.tags && (
              <Typography color="error" fontSize={12}>
                {formErrors.tags}
              </Typography>
            )}

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 4,
              }}
            >
              <Button
                onClick={onClose}
                sx={{
                  backgroundColor: "#F4F0FF",
                  color: "#0047AB",
                  textTransform: "none",
                  borderRadius: "8px",
                  px: 3,
                  "&:hover": {
                    backgroundColor: "#EDE8FF",
                  },
                }}
              >
                Cancel
              </Button>
              {loader ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#0047AB",
                    textTransform: "none",
                    borderRadius: "8px",
                    px: 3,
                    "&:hover": {
                      backgroundColor: "#001F5F",
                    },
                  }}
                  onClick={handleSubmit}
                >
                  Confirm
                </Button>
              )}
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={bulkUpload}
          onClose={onClose}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#484848",
            }}
          >
            Bulk Upload
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            {/* Upload Box */}
            <label htmlFor="upload-zip" style={{ width: "100%", display: "block" }}>
              <Box
                sx={{
                  border: "1px dashed #D9E1EC",
                  borderRadius: "8px",
                  background: "#F8FAFC",
                  p: 2,
                  textAlign: "center",
                  mb: 2,
                  cursor: !file ? "pointer" : "default",
                  transition: "background-color 0.2s ease, border-color 0.2s ease",
                  "&:hover": {
                    backgroundColor: !file ? "#F1F5F9" : "#F8FAFC",
                    borderColor: !file ? "#2563EB" : "#D9E1EC",
                  },
                }}
              >
                {!file ? (
                  <>
                    <CloudUploadIcon sx={{ fontSize: 40, color: "#F97316" }} />
                    <Typography variant="body2" sx={{ mt: 1, color: "#1E293B", fontWeight: 500 }}>
                      Upload Zip File
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                      Max size 250 MB. Only ZIP files are supported{" "}
                      <span style={{ color: "#2563EB", fontWeight: 600, textDecoration: "underline" }}>
                        BROWSE
                      </span>
                    </Typography>
                    <input
                      type="file"
                      accept=".zip"
                      onChange={handleZipFileUpload}
                      style={{ display: "none" }}
                      id="upload-zip"
                    />
                  </>
                ) : (
                  <Box sx={{ textAlign: "left" }} onClick={(e) => e.stopPropagation()}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography sx={{ flexGrow: 1 }}>{file.name}</Typography>
                    </Box>
                    <Box display="flex" gap={2} alignItems="center">
                      <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{ height: 10, width: "95%", borderRadius: "4px" }}
                      />
                      <Typography variant="body2" sx={{ minWidth: 35 }}>
                        {progress}%
                      </Typography>
                      <IconButton size="small" onClick={handleDeleteFile}>
                        <img src={deleteicon} width={20} height={20} alt="delete" />
                      </IconButton>
                    </Box>
                    <Typography variant="caption">
                    Total Items:{" "}
                    <span style={{ color: "#2D76DC" }}>{totalItems}</span> |
                    Success:{" "}
                    <span style={{ color: "#1CCE0F" }}>{successCount}</span> |
                    Failed:{" "}
                    <span style={{ color: "#DB3B13" }}>{failedCount}</span>
                  </Typography>
                </Box>
              )}
            </Box>
            </label>
            <Typography mt={2} fontSize={"16px"} mb={1}>
              Choose For All
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Box width={{ xs: "100%", md: "50%" }}>
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 400,
                    color: "#95919D",
                  }}
                  mb={0.5}
                >
                  Category
                </Typography>
                <TextField
                  select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  fullWidth
                  // variant="standard"
                  InputLabelProps={{
                    sx: {
                      color: "#ccc",
                      fontSize: "16px",
                    },
                  }}
                  SelectProps={{
                    IconComponent: () => (
                      <svg
                        width="30px"
                        height="25px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7 10l5 5 5-5H7z" fill="#2D76DC" />
                      </svg>
                    ),
                    sx: {
                      paddingTop: "4px",
                    },
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottom: "1px solid #E0E0E0",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: "1px solid #E0E0E0",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottom: "1px solid #E0E0E0",
                    },
                    "& .MuiSelect-select": {
                      padding: "14.5px 14px", // top-bottom, left-right
                    },
                    "& .MuiInputBase-root": {
                      height: 45, // total height of the input box
                    },
                  }}
                >
                  {categoriesData?.map((cat) => (
                    <MenuItem key={cat?.id} value={cat?.id}>
                      {cat?.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            {/* Trending Topics / Tags Section - Made optional & hidden */}
            {/* 
              <Box
                width={{ xs: "100%", md: "49%" }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                  gap: 1,
                }}
              >
                <Autocomplete
                  freeSolo
                  options={trendsData.filter(
                    (trend) =>
                      trend.toLowerCase().includes(trendsInput.toLowerCase()) &&
                      !selectedTrends.includes(trend)
                  )}
                  inputValue={trendsInput}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      setTrendsInput(newInputValue);
                    } else if (reason === "reset" || reason === "clear") {
                      setTrendsInput("");
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      addTrends(newValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      sx={{
                        color: "#E0E0E0",
                        "& .MuiInputBase-input": {
                          fontSize: "12px",
                        },
                      }}
                      placeholder="Trending Topics"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          addTrends(trendsInput);
                        }
                      }}
                    />
                  )}
                  PopperComponent={(props) => (
                    <Popper
                      {...props}
                      sx={{
                        width: "200px",
                        padding: "8px",
                        "& .MuiAutocomplete-listbox": {
                          padding: "5px",
                          border: "1px solid #DEDFE5",
                          borderRadius: "8px",
                          "& li": {
                            backgroundColor: "#FFFFFF",
                            padding: "8px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                          },
                          "& li:hover": {
                            backgroundColor: "#0047AB",
                            color: "#FFFFFF",
                          },
                        },
                      }}
                    />
                  )}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option || ""
                  }
                  disableClearable
                />
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {selectedTrends?.map((trend, index) => (
                    <Chip
                      key={index}
                      label={trend}
                      onDelete={() => removeTrends(trend)}
                      deleteIcon={<CloseIcon fontSize="10px" />}
                      sx={{
                        backgroundColor: "#E7F1FF",
                        border: "1px solid #2D76DC",
                        color: "#2D76DC",
                        fontWeight: 400,
                        fontSize: "10px",
                        height: "24px",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            */}
            </Box>

            {/* Actions */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                onClick={onClose}
                sx={{
                  backgroundColor: "#F4F0FF",
                  color: "#0047AB",
                  textTransform: "none",
                  borderRadius: "8px",
                  px: 3,
                  "&:hover": {
                    backgroundColor: "#EDE8FF",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleZipConfirm}
                sx={{
                  backgroundColor: "#0047AB",
                  textTransform: "none",
                  borderRadius: "8px",
                  color: "#fff",
                  px: 3,
                  "&:hover": {
                    backgroundColor: "#001F5F",
                  },
                }}
              >
                Confirm
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Card>
    </>
  );
};

export default VideoManagement;

